import {enumType} from 'common/enumType';

export const FtpTransferMode = enumType({
   ASCII: 'ASCII',
   BINARY: 'Binary',
});
